import { motion } from "framer-motion";
import { LoadingStatus } from "./LoadingStatus";

export const SkeletonLoader = () => {
  return (
    <div className="flex flex-col min-h-[60vh]">
      <LoadingStatus type="generate" />

      <div className="px-6 space-y-4 mt-4">
        {[1, 2, 3, 4, 5].map((i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            className="bg-card rounded-2xl border border-border p-4"
          >
            <div className="flex items-start justify-between">
              <div className="space-y-2 flex-1">
                <div className="h-5 w-40 rounded-lg bg-secondary animate-shimmer bg-gradient-to-r from-secondary via-muted to-secondary bg-[length:200%_100%]" />
                <div className="h-4 w-24 rounded-lg bg-secondary animate-shimmer bg-gradient-to-r from-secondary via-muted to-secondary bg-[length:200%_100%]" />
              </div>
              <div className="w-10 h-10 rounded-xl bg-secondary animate-shimmer bg-gradient-to-r from-secondary via-muted to-secondary bg-[length:200%_100%]" />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
